import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import DepositsContent from '../components/DepositsContent';

export default function Deposits() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="yatirim-gecmisi" />
                    <DepositsContent />
                </div>
            </div>
        </div>
    );
}
